var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolidCircleQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256 57.25C146.233 57.25 57.25 146.233 57.25 256C57.25 365.767 146.233 454.75 256 454.75C365.767 454.75 454.75 365.767 454.75 256C454.75 146.233 365.767 57.25 256 57.25ZM256 375.25C241.094 375.25 229.5 363.656 229.5 348.75C229.5 333.844 241.094 322.25 256 322.25C270.906 322.25 282.5 333.844 282.5 348.75C282.5 363.656 270.906 375.25 256 375.25ZM313.969 257.656L275.875 280.844V282.5C275.875 293.266 266.766 302.375 256 302.375C245.234 302.375 236.125 293.266 236.125 282.5V269.25C236.125 262.625 239.438 256 246.062 251.859L293.266 223.703C299.062 220.391 302.375 214.594 302.375 207.969C302.375 198.031 294.094 189.75 284.156 189.75H241.094C231.156 189.75 222.875 198.031 222.875 207.969C222.875 218.734 213.766 227.844 203 227.844C192.234 227.844 183.125 218.734 183.125 207.969C183.125 175.672 208.797 150 241.094 150H284.156C316.453 150 342.125 175.672 342.125 207.969C342.125 227.844 331.359 246.891 313.969 257.656Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolidCircleQuestion);
export default __webpack_public_path__ + "static/media/solid_circle-question.ff8b6f7b3f71f28cb2a5106c65ca79c9.svg";
export { ForwardRef as ReactComponent };